module.exports = __webpack_public_path__ + "static/media/space-gif2.d25558e9.gif";